import { render } from "./DetailLaporanLkpm.vue?vue&type=template&id=319e2c07"
import script from "./DetailLaporanLkpm.vue?vue&type=script&lang=js"
export * from "./DetailLaporanLkpm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__